import React from 'react';
import { Modal, MimaText, MimaButton, PageLoader } from '../../components';

const DeletePaymentLink = ({
	closeModal,
	selectedLink,
	loading,
	confirmDelete,
}) => {
	return (
		<Modal closeModal={closeModal}>
			{loading ? (
				<PageLoader title="Deactivation in progress" />
			) : (
				<>
					<MimaText variant="subtitleBold" mb={2} align="center">
						Deactivate Payment Link
					</MimaText>
					<MimaText width={38} align="center" mb={2}>
						Are you sure you want to deactivate{' '}
						<span
							style={{
								fontWeight: '700',
								color: 'var(--color-primary)',
							}}>
							{selectedLink.title}
						</span>
					</MimaText>
					<div
						style={{
							display: 'flex',
							width: '38rem',
							justifyContent: 'space-between',
						}}>
						<MimaButton
							title="Yes, Deactivate"
							width={20}
							onClick={confirmDelete}
						/>
						<MimaButton
							title="No"
							buttonColor="var(--color-dark)"
							width={16}
							onClick={closeModal}
						/>
					</div>
				</>
			)}
		</Modal>
	);
};

export default DeletePaymentLink;
